import { Divider } from '@components/core-ui/Divider';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import { GetBillingAccountResponseDto } from 'app/API';
import { Link } from 'react-router-dom';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  billingAccount: GetBillingAccountResponseDto;
  onSuccess?: () => void;
};

export type PlanSelection = {
  subscriptionProductId: string;
  planName: string;
  price: number;
  freeSeats: number;
};

export const AddSubscription = ({ billingAccount, onSuccess }: TProps) => {
  const { openModal, closeModal } = useModalContext();
  const { organization } = useAuthContext();

  const onClick = () => {
    openModal(ModalNamesEnum.ChooseASOneSubscriptionModal, {
      billingAccountId: billingAccount.id,
      onSuccess: ({ subscriptionProductId, planName, price, freeSeats }: PlanSelection) => {
        openModal(ModalNamesEnum.ConfirmSubscription, {
          billingAccountId: billingAccount.id,
          subscriptionProductId,
          planName,
          freeSeats,
          onSuccess: (id?: string) => {
            const successHandler = () => {
              closeModal();
              if (onSuccess) {
                onSuccess();
              }
            };
            openModal(ModalNamesEnum.GenericConfirmation, {
              title: 'Success!',
              description: (
                <span className="text-sm">
                  To start working with AutoScriptOne you will need to visit the Subscription Details page and assign
                  licenses for reporters.
                  <br />
                  <br />
                  You can open the Subscription Details page by{' '}
                  <Link to={routes.autoScriptOneSubscriptionDetails.make(organization?.slug, id)} className="underline">
                    clicking here
                  </Link>{' '}
                  or by clicking on your subscription on a Billing Details page
                </span>
              ),
              buttonText: 'Ok',
              onSuccess: successHandler,
              onCancel: false,
            });
          },
          price: Number(price),
        });
      },
    });
  };

  if (billingAccount.subscriptions?.length) {
    return null;
    // return (
    //   <Wrapper onClick={onClick}>
    //     <div className="title">Upgrade</div>
    //     <Divider className="divider" />
    //     <div className="text">Expand your access: add subscription to your account</div>
    //   </Wrapper>
    // );
  }

  return (
    <Wrapper onClick={onClick}>
      <div className="title">AutoScriptOne</div>
      <Divider className="divider" />
      <div className="text">RealTime Reporter Capture Tool</div>
      <div className="button">+ Add Subscription</div>
    </Wrapper>
  );
};
